import { toCanonicalDateFromPtBr } from "@/utils/date";

export const articlesList = [
  {
    id: 1,
    slug: "melhor-tv-50-polegadas-2024",
    title: "Qual a Melhor TV 50 Polegadas de 2024? Testamos 12 Modelos",
    metaTitle: "Melhor TV 50 Polegadas 2024 | Comparativo Completo + Onde Comprar",
    metaDescription: "Testamos 12 TVs 50 polegadas e elegemos as melhores de 2024. Veja comparativo de qualidade de imagem, smart TV, custo-benefício e onde comprar mais barato.",
    category: "Televisores",
    categorySlug: "televisores",
    readTime: "12 min",
    date: "08 Abr 2024",
    updatedDate: "09 Abr 2024",
    views: 48291,
    author: "Equipe AfiliaBR",
    authorAvatar: "https://readdy.ai/api/search-image?query=professional%20tech%20reviewer%20portrait%20smiling%20confident%20person%20clean%20background%20editorial%20photography&width=80&height=80&seq=author1&orientation=squarish",
    heroImage: "https://readdy.ai/api/search-image?query=multiple%2050%20inch%204K%20smart%20TVs%20comparison%20review%20editorial%20photography%20modern%20living%20room%20setup%20Samsung%20LG%20Sony%20side%20by%20side&width=1200&height=600&seq=hero1&orientation=landscape",
    excerpt: "Comparamos as principais TVs 50 polegadas do mercado em resolução, qualidade de imagem, smart TV e custo-benefício. Veja qual vale a pena comprar.",
    tags: ["TV 50 polegadas", "Smart TV", "4K", "Samsung", "LG", "Sony"],
    tableOfContents: [
      { id: "resumo", label: "Resumo Rápido" },
      { id: "top-picks", label: "Top 5 Melhores TVs 50\"" },
      { id: "como-escolher", label: "Como Escolher a TV Certa" },
      { id: "tecnologias", label: "Crystal UHD vs QLED vs OLED" },
      { id: "faq", label: "Perguntas Frequentes" },
    ],
    sections: [
      {
        id: "resumo",
        type: "intro",
        content: `Se você está buscando a **melhor TV 50 polegadas de 2024**, chegou ao lugar certo. Testamos 12 modelos durante 30 dias cada, avaliando qualidade de imagem, sistema smart TV, desempenho em jogos, consumo de energia e custo-benefício.

A TV 50 polegadas é o tamanho ideal para salas de até 20m² — grande o suficiente para uma experiência cinematográfica, mas sem ocupar toda a parede. Em 2024, o mercado evoluiu muito: praticamente todos os modelos já vêm com 4K, e a diferença está nas tecnologias de painel e nos sistemas operacionais.

Neste guia completo, você vai encontrar as melhores opções por categoria de uso e orçamento, além de um comparativo técnico detalhado para você tomar a melhor decisão de compra.`,
      },
      {
        id: "top-picks",
        type: "products",
        title: "Top 5 Melhores TVs 50 Polegadas de 2024",
        content: `Após testes rigorosos, estas são as TVs 50 polegadas que mais se destacaram em 2024:`,
        products: [
          {
            rank: 1,
            badge: "Melhor Custo-Benefício",
            name: "Samsung Smart TV 50\" Crystal UHD 4K 2024",
            slug: "samsung-smart-tv-50-crystal-uhd-4k-2024",
            image: "https://readdy.ai/api/search-image?query=Samsung%2050%20inch%204K%20Smart%20TV%20Crystal%20UHD%202024%20front%20view%20clean%20white%20background%20product%20photography%20professional%20studio&width=400&height=300&seq=tv1&orientation=landscape",
            price: 2199.99,
            originalPrice: 3499.99,
            discount: 37,
            rating: 4.8,
            reviews: 2341,
            marketplace: "Amazon",
            affiliateLink: "#",
            highlight: "Melhor opção para quem quer qualidade 4K sem gastar muito. Sistema Tizen fluido e compatível com Alexa.",
          },
          {
            rank: 2,
            badge: "Melhor Imagem",
            name: "LG OLED 50\" evo C3 4K 120Hz",
            slug: "lg-oled-50-evo-c3-4k-120hz",
            image: "https://readdy.ai/api/search-image?query=LG%20OLED%2050%20inch%20C3%20evo%204K%20TV%20front%20view%20clean%20white%20background%20product%20photography%20professional%20studio%20lighting&width=400&height=300&seq=tv2&orientation=landscape",
            price: 5499.00,
            originalPrice: 7999.00,
            discount: 31,
            rating: 4.9,
            reviews: 1892,
            marketplace: "Amazon",
            affiliateLink: "#",
            highlight: "Pretos perfeitos, contraste infinito e 120Hz para jogos. A melhor qualidade de imagem disponível em 50\".",
          },
          {
            rank: 3,
            badge: "Melhor para Games",
            name: "Sony Bravia X80L 50\" 4K Google TV",
            slug: "sony-bravia-x80l-50-4k-google-tv",
            image: "https://readdy.ai/api/search-image?query=Sony%20Bravia%20X80L%2050%20inch%204K%20Google%20TV%20front%20view%20clean%20white%20background%20product%20photography%20professional%20studio&width=400&height=300&seq=tv3&orientation=landscape",
            price: 3299.00,
            originalPrice: 4599.00,
            discount: 28,
            rating: 4.7,
            reviews: 1203,
            marketplace: "Mercado Livre",
            affiliateLink: "#",
            highlight: "Google TV nativo, HDMI 2.1 para PS5/Xbox Series X em 4K/120fps e processador X1 da Sony.",
          },
          {
            rank: 4,
            badge: "Melhor QLED",
            name: "Samsung Neo QLED 50\" QN90C 4K 144Hz",
            slug: "samsung-neo-qled-50-qn90c-4k-144hz",
            image: "https://readdy.ai/api/search-image?query=Samsung%20Neo%20QLED%2050%20inch%20QN90C%204K%20TV%20front%20view%20clean%20white%20background%20product%20photography%20professional%20studio%20lighting&width=400&height=300&seq=tv4&orientation=landscape",
            price: 4799.00,
            originalPrice: 6999.00,
            discount: 31,
            rating: 4.8,
            reviews: 987,
            marketplace: "Amazon",
            affiliateLink: "#",
            highlight: "Mini LED com 144Hz, brilho altíssimo para ambientes claros e Dolby Atmos. Ideal para salas iluminadas.",
          },
          {
            rank: 5,
            badge: "Melhor Entrada",
            name: "TCL 50\" P635 4K Google TV",
            slug: "tcl-50-p635-4k-google-tv",
            image: "https://readdy.ai/api/search-image?query=TCL%2050%20inch%20P635%204K%20Google%20TV%20front%20view%20clean%20white%20background%20product%20photography%20professional%20studio&width=400&height=300&seq=tv5&orientation=landscape",
            price: 1599.00,
            originalPrice: 2299.00,
            discount: 30,
            rating: 4.4,
            reviews: 3421,
            marketplace: "Shopee",
            affiliateLink: "#",
            highlight: "Melhor preço do mercado com Google TV nativo. Ótima opção para quem quer entrar no 4K gastando pouco.",
          },
        ],
      },
      {
        id: "como-escolher",
        type: "guide",
        title: "Como Escolher a Melhor TV 50 Polegadas",
        content: `Antes de comprar uma TV 50 polegadas, você precisa considerar alguns fatores essenciais que vão determinar qual modelo é o ideal para o seu uso:

**1. Distância de visualização**
Para uma TV 50 polegadas 4K, a distância ideal de visualização é entre 1,5m e 2,5m. Se você vai sentar mais longe, considere um modelo maior.

**2. Tipo de uso principal**
- **Filmes e séries**: Priorize OLED ou QLED com HDR Dolby Vision
- **Jogos**: Procure HDMI 2.1, 120Hz e VRR (Variable Refresh Rate)
- **Esportes ao vivo**: Alta taxa de atualização (120Hz) e Motion Rate alto
- **Uso geral**: Crystal UHD ou LED 4K com bom sistema smart TV

**3. Ambiente da sala**
- **Sala escura**: OLED é a melhor escolha (pretos perfeitos)
- **Sala clara/iluminada**: QLED ou Neo QLED (maior brilho)

**4. Sistema Smart TV**
- **Tizen (Samsung)**: Mais fluido e com mais apps
- **webOS (LG)**: Interface intuitiva e excelente
- **Google TV (Sony, TCL)**: Melhor integração com Google e Android

**5. Orçamento**
- **Até R$ 2.000**: TCL, Hisense, Philips
- **R$ 2.000 a R$ 3.500**: Samsung Crystal UHD, Sony X80L
- **R$ 3.500 a R$ 6.000**: Samsung QLED, LG QNED
- **Acima de R$ 6.000**: LG OLED, Samsung Neo QLED`,
      },
      {
        id: "tecnologias",
        type: "comparison",
        title: "Crystal UHD vs QLED vs OLED: Qual é Melhor?",
        content: `Esta é a dúvida mais comum de quem está comprando uma TV 50 polegadas. Veja o comparativo completo:`,
        comparisonTable: [
          { feature: "Qualidade de Imagem", crystal: "Boa", qled: "Muito Boa", oled: "Excelente" },
          { feature: "Pretos e Contraste", crystal: "Regular", qled: "Boa", oled: "Perfeito" },
          { feature: "Brilho", crystal: "Médio", qled: "Alto", oled: "Médio-Alto" },
          { feature: "Sala Iluminada", crystal: "Regular", qled: "Excelente", oled: "Boa" },
          { feature: "Sala Escura", crystal: "Boa", qled: "Muito Boa", oled: "Perfeita" },
          { feature: "Para Jogos", crystal: "Regular", qled: "Muito Boa", oled: "Excelente" },
          { feature: "Consumo de Energia", crystal: "Baixo", qled: "Médio", oled: "Médio" },
          { feature: "Preço Médio 50\"", crystal: "R$ 1.800-3.000", qled: "R$ 3.500-6.000", oled: "R$ 5.000-9.000" },
        ],
      },
    ],
    faqs: [
      {
        question: "Qual a melhor TV 50 polegadas custo-benefício em 2024?",
        answer: "A Samsung Crystal UHD 50\" 4K é a melhor opção custo-benefício em 2024. Ela oferece resolução 4K, sistema Tizen fluido com todos os apps principais, compatibilidade com Alexa e Google Assistant, e está disponível por cerca de R$ 2.200 na Amazon — um preço excelente para o que entrega.",
      },
      {
        question: "TV 50 polegadas serve para sala de quanto m²?",
        answer: "Uma TV 50 polegadas é ideal para salas entre 12m² e 25m². A distância de visualização recomendada é de 1,5m a 2,5m. Para salas maiores, considere modelos de 55\" ou 65\". Para salas menores, um modelo de 43\" pode ser mais adequado.",
      },
      {
        question: "Vale a pena pagar mais por OLED em 50 polegadas?",
        answer: "Depende do uso. Se você assiste muitos filmes em ambiente escuro e valoriza qualidade de imagem acima de tudo, o OLED vale cada centavo — os pretos são perfeitos e o contraste é incomparável. Para uso geral ou sala iluminada, um QLED ou Crystal UHD de qualidade entrega ótimos resultados por muito menos.",
      },
      {
        question: "TV 50 polegadas com HDMI 2.1 vale a pena para PS5?",
        answer: "Sim, se você tem PS5 ou Xbox Series X, o HDMI 2.1 permite jogar em 4K/120fps, o que faz uma diferença enorme em jogos compatíveis. O Sony Bravia X80L e o Samsung Neo QLED QN90C são as melhores opções 50\" com HDMI 2.1 no mercado brasileiro.",
      },
      {
        question: "Qual TV 50 polegadas tem o melhor sistema smart TV?",
        answer: "O Tizen da Samsung é considerado o mais fluido e completo, com a maior biblioteca de apps. O Google TV (Sony, TCL) tem a melhor integração com o ecossistema Google e Android. O webOS da LG é muito intuitivo e tem Magic Remote. Todos são excelentes — a escolha depende do ecossistema que você já usa.",
      },
      {
        question: "Onde comprar TV 50 polegadas mais barata?",
        answer: "Monitoramos os preços diariamente em Amazon, Mercado Livre, Magazine Luiza, Americanas e Shopee. Historicamente, a Amazon e o Mercado Livre têm os melhores preços com frete grátis. Clique nos botões 'Ver Oferta' nos produtos acima para ser redirecionado ao preço mais atualizado.",
      },
    ],
    relatedArticles: [
      {
        slug: "melhor-notebook-custo-beneficio-2024",
        title: "Melhor Notebook Custo-Benefício 2024: Top 10 Opções",
        image: "https://readdy.ai/api/search-image?query=laptop%20notebooks%20comparison%20review%20editorial%20photography%20desk%20workspace%20multiple%20models%20professional&width=400&height=250&seq=rel1&orientation=landscape",
        readTime: "15 min",
        category: "Notebooks",
      },
      {
        slug: "iphone-15-vale-a-pena-review",
        title: "iPhone 15 Vale a Pena? Review Completo Após 3 Meses",
        image: "https://readdy.ai/api/search-image?query=iPhone%2015%20review%20editorial%20photography%20hands%20holding%20smartphone%20camera%20test%20outdoor%20lifestyle%20professional&width=400&height=250&seq=rel2&orientation=landscape",
        readTime: "10 min",
        category: "Smartphones",
      },
      {
        slug: "melhor-air-fryer-2024",
        title: "Melhor Air Fryer 2024: Qual Comprar? Comparativo",
        image: "https://readdy.ai/api/search-image?query=air%20fryer%20comparison%20review%20editorial%20photography%20kitchen%20appliances%20multiple%20models%20food%20cooking%20professional&width=400&height=250&seq=rel3&orientation=landscape",
        readTime: "8 min",
        category: "Eletrodomésticos",
      },
    ],
  },
].map((article) => ({
  ...article,
  date: toCanonicalDateFromPtBr(article.date),
  updatedDate: toCanonicalDateFromPtBr(article.updatedDate),
}));

export const allGuides = [
  {
    id: 1,
    slug: "melhor-tv-50-polegadas-2024",
    title: "Qual a Melhor TV 50 Polegadas de 2024? Testamos 12 Modelos",
    excerpt: "Comparamos as principais TVs 50 polegadas do mercado em resolução, qualidade de imagem, smart TV e custo-benefício.",
    category: "Televisores",
    categorySlug: "televisores",
    type: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=multiple%2050%20inch%204K%20smart%20TVs%20comparison%20review%20editorial%20photography%20modern%20living%20room%20setup%20Samsung%20LG%20Sony&width=800&height=500&seq=guide1&orientation=landscape",
    readTime: "12 min",
    date: "08 Abr 2024",
    views: 48291,
    featured: true,
    trending: true,
  },
  {
    id: 2,
    slug: "melhor-notebook-custo-beneficio-2024",
    title: "Melhor Notebook Custo-Benefício 2024: Top 10 Opções",
    excerpt: "Encontre o notebook ideal para trabalho, estudo ou jogos sem gastar muito. Análise completa com prós, contras e onde comprar mais barato.",
    category: "Notebooks",
    categorySlug: "notebooks",
    type: "Guia de Compra",
    image: "https://readdy.ai/api/search-image?query=laptop%20notebooks%20comparison%20review%20editorial%20photography%20desk%20workspace%20multiple%20models%20professional%20studio&width=800&height=500&seq=guide2&orientation=landscape",
    readTime: "15 min",
    date: "07 Abr 2024",
    views: 32104,
    featured: false,
    trending: true,
  },
  {
    id: 3,
    slug: "iphone-15-vale-a-pena-review",
    title: "iPhone 15 Vale a Pena? Review Completo Após 3 Meses de Uso",
    excerpt: "Usamos o iPhone 15 por 3 meses e testamos câmera, bateria, desempenho e comparamos com a concorrência.",
    category: "Smartphones",
    categorySlug: "smartphones",
    type: "Review",
    image: "https://readdy.ai/api/search-image?query=iPhone%2015%20review%20editorial%20photography%20hands%20holding%20smartphone%20camera%20test%20outdoor%20lifestyle%20professional&width=800&height=500&seq=guide3&orientation=landscape",
    readTime: "10 min",
    date: "06 Abr 2024",
    views: 27893,
    featured: false,
    trending: false,
  },
  {
    id: 4,
    slug: "melhor-air-fryer-2024",
    title: "Melhor Air Fryer 2024: Qual Comprar? Comparativo Completo",
    excerpt: "Testamos as principais air fryers do mercado e elegemos as melhores por categoria: capacidade, preço e facilidade de uso.",
    category: "Eletrodomésticos",
    categorySlug: "eletrodomesticos",
    type: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=air%20fryer%20comparison%20review%20editorial%20photography%20kitchen%20appliances%20multiple%20models%20food%20cooking%20professional&width=800&height=500&seq=guide4&orientation=landscape",
    readTime: "8 min",
    date: "05 Abr 2024",
    views: 19432,
    featured: false,
    trending: false,
  },
  {
    id: 5,
    slug: "melhor-fone-bluetooth-2024",
    title: "Melhor Fone Bluetooth 2024: Top 8 com Cancelamento de Ruído",
    excerpt: "Do JBL ao Sony, testamos os melhores fones sem fio com ANC do mercado. Veja qual entrega o melhor som pelo menor preço.",
    category: "Fones de Ouvido",
    categorySlug: "fones-de-ouvido",
    type: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=wireless%20headphones%20comparison%20review%20editorial%20photography%20multiple%20models%20Sony%20JBL%20Bose%20clean%20studio%20background&width=800&height=500&seq=guide5&orientation=landscape",
    readTime: "11 min",
    date: "04 Abr 2024",
    views: 15820,
    featured: false,
    trending: true,
  },
  {
    id: 6,
    slug: "ps5-vs-xbox-series-x-2024",
    title: "PS5 vs Xbox Series X: Qual Console Comprar em 2024?",
    excerpt: "Comparamos desempenho, catálogo de jogos, serviços online e preço do PS5 Slim e Xbox Series X para você decidir.",
    category: "Games",
    categorySlug: "games",
    type: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=PlayStation%205%20vs%20Xbox%20Series%20X%20comparison%20editorial%20photography%20gaming%20consoles%20side%20by%20side%20clean%20studio%20background&width=800&height=500&seq=guide6&orientation=landscape",
    readTime: "14 min",
    date: "03 Abr 2024",
    views: 41230,
    featured: false,
    trending: true,
  },
  {
    id: 7,
    slug: "melhor-geladeira-frost-free-2024",
    title: "Melhor Geladeira Frost Free 2024: Guia Completo de Compra",
    excerpt: "Brastemp, Consul, Samsung ou LG? Analisamos as melhores geladeiras frost free por capacidade, consumo e preço.",
    category: "Eletrodomésticos",
    categorySlug: "eletrodomesticos",
    type: "Guia de Compra",
    image: "https://readdy.ai/api/search-image?query=refrigerator%20frost%20free%20comparison%20review%20editorial%20photography%20multiple%20models%20kitchen%20appliances%20professional%20studio&width=800&height=500&seq=guide7&orientation=landscape",
    readTime: "9 min",
    date: "02 Abr 2024",
    views: 12340,
    featured: false,
    trending: false,
  },
  {
    id: 8,
    slug: "melhor-smartwatch-2024",
    title: "Melhor Smartwatch 2024: Apple Watch vs Galaxy Watch vs Garmin",
    excerpt: "Testamos os principais smartwatches do mercado em saúde, GPS, bateria e integração com smartphone.",
    category: "Smartwatches",
    categorySlug: "smartwatches",
    type: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=smartwatch%20comparison%20Apple%20Watch%20Samsung%20Galaxy%20Garmin%20editorial%20photography%20wrist%20multiple%20models%20clean%20studio&width=800&height=500&seq=guide8&orientation=landscape",
    readTime: "13 min",
    date: "01 Abr 2024",
    views: 22180,
    featured: false,
    trending: false,
  },
  {
    id: 9,
    slug: "como-escolher-notebook-gamer",
    title: "Como Escolher um Notebook Gamer: Guia Definitivo 2024",
    excerpt: "GPU, CPU, RAM, tela e refrigeração — tudo que você precisa saber antes de comprar um notebook gamer.",
    category: "Notebooks",
    categorySlug: "notebooks",
    type: "Guia de Compra",
    image: "https://readdy.ai/api/search-image?query=gaming%20laptop%20notebook%20RGB%20keyboard%20glowing%20screen%20dark%20background%20editorial%20photography%20professional%20studio&width=800&height=500&seq=guide9&orientation=landscape",
    readTime: "18 min",
    date: "31 Mar 2024",
    views: 29450,
    featured: false,
    trending: false,
  },
  {
    id: 10,
    slug: "melhor-monitor-para-trabalho-2024",
    title: "Melhor Monitor para Trabalho 2024: Home Office e Design",
    excerpt: "Do Full HD ao 4K, testamos os melhores monitores para produtividade, design gráfico e home office.",
    category: "Informática",
    categorySlug: "informatica",
    type: "Guia de Compra",
    image: "https://readdy.ai/api/search-image?query=computer%20monitor%20desk%20setup%20home%20office%20work%20editorial%20photography%20multiple%20screens%20professional%20clean%20background&width=800&height=500&seq=guide10&orientation=landscape",
    readTime: "10 min",
    date: "30 Mar 2024",
    views: 17890,
    featured: false,
    trending: false,
  },
  {
    id: 11,
    slug: "samsung-galaxy-s24-review",
    title: "Samsung Galaxy S24 Review: Vale a Pena em 2024?",
    excerpt: "Testamos o Galaxy S24 por 60 dias. Câmera, Galaxy AI, bateria e desempenho — veja se vale o investimento.",
    category: "Smartphones",
    categorySlug: "smartphones",
    type: "Review",
    image: "https://readdy.ai/api/search-image?query=Samsung%20Galaxy%20S24%20review%20editorial%20photography%20hands%20holding%20smartphone%20outdoor%20lifestyle%20professional%20studio&width=800&height=500&seq=guide11&orientation=landscape",
    readTime: "12 min",
    date: "29 Mar 2024",
    views: 33210,
    featured: false,
    trending: true,
  },
  {
    id: 12,
    slug: "melhor-aspirador-robo-2024",
    title: "Melhor Aspirador Robô 2024: Top 6 Testados",
    excerpt: "Roomba, Roborock ou Xiaomi? Testamos os principais aspiradores robô em limpeza, autonomia e app.",
    category: "Eletrodomésticos",
    categorySlug: "eletrodomesticos",
    type: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=robot%20vacuum%20cleaner%20comparison%20review%20editorial%20photography%20multiple%20models%20clean%20floor%20home%20interior%20professional&width=800&height=500&seq=guide12&orientation=landscape",
    readTime: "9 min",
    date: "28 Mar 2024",
    views: 14560,
    featured: false,
    trending: false,
  },
].map((guide) => ({
  ...guide,
  date: toCanonicalDateFromPtBr(guide.date),
}));

export const guideCategories = ["Todos", "Televisores", "Smartphones", "Notebooks", "Eletrodomésticos", "Games", "Fones de Ouvido", "Smartwatches", "Informática"];
export const guideTypes = ["Todos", "Review", "Compra"];

export const getArticleBySlug = (slug: string) =>
  articlesList.find((a) => a.slug === slug) ?? articlesList[0];